<template>
  <div class="home_page_root">
  <div class="Index" v-if="!is_mobile">
    <div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
      <headNav :activeNav="'Inicio'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88">
        <homeNav :activeNav="'Inicio'"></homeNav>
      </div>
      <div class="libe_home_banner" style="border-radius: 0 0 70px 70px;overflow: hidden;">
        <div class="libe_home_banner_img">
          <img src="../assets/imgs/home_banner01.jpg" alt="">
        </div>
      </div>

      <div class="eshoy_home_google_link">
        <div class="google_link_wrap">
          <a
                  href="https://play.google.com/store/apps/details?id=cash.prestamos.credit.instalacion.kueski.plapla"
                  target="_blank"
                  class="playBtn"
          >
          <img src="../assets/imgs/google_icon.png" alt="">
          </a>
        </div>
        <div class="ios_link_wrap">
          <!--<img src="../assets/imgs/ios_icon.png" alt="">-->
        </div>
      </div>

      <div class="libe_home_top">
        <div class="libe_home_top_img">
          <img src="../assets/imgs/eshoy_home_top01.png" alt="">
        </div>
      </div>

      <div class="eshoy_slider_wrap">
        <div class="eshoy_slider_cont">
          <div class="loan-content-box">
            <div class="moneybox">
              $ <span id="money">{{ dealNumber(sliderValue) }}</span>
            </div>
            <div class="loan-select-box">
              <div class="loan-select-item"
                   :class="isActive == 91 ? 'selected' : ''"
                   @click="getDays(91)"
              >
                91 Días
              </div>
              <div class="loan-select-item"
                   :class="isActive == 120 ? 'selected' : ''"
                   @click="getDays(120)"
              >
                120 Días
              </div>
              <div class="loan-select-item"
                   :class="isActive == 180 ? 'selected' : ''"
                   @click="getDays(180)"
              >
                180 Días
              </div>
            </div>

            <div class="sliderbox_wrap">
              <div class="sliderbox_left">
                <div class="sliderbox_cimg">
                  <img src="@/assets/img/eshoy_gold_small.png" alt="">
                </div>
                <div class="sliderbox_ctext">$<span>200</span></div>
              </div>
              <div class="sliderbox_middle">
                <div class="sliderBox">
                  <el-slider
                          v-model="sliderValue"
                          :min="200"
                          :max="24000"
                          :show-tooltip="false"
                  ></el-slider>
                </div>
              </div>
              <div class="sliderbox_right">
                <div class="sliderbox_cimg">
                  <img src="@/assets/img/eshoy_gold_more.png" alt="">
                </div>
                <div class="sliderbox_ctext">$<span>24,000</span></div>
              </div>
            </div>
          </div>
          <div class="eshoy_slider_btns">
            <div class="eshoy_slider_btn_view animate__animated animate__infinite animate__pulse">
              <img src="@/assets/imgs/plapla_slider_btn.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="plapla_centro_view">
      <div class="plapla_centro_wrap">
        <div class="plapla_centro_cont">
          <img src="@/assets/imgs/eshoy_home_top02.png" alt="" />
        </div>
        <div class="plapla_centro_desc">Si te surge más dudas, venga a sección de <span @click="gotoHelp">preguntas frecuentes.&rarr;</span></div>
      </div>
    </div>

    <!--<div class="plapla_centro_view">
      <div class="plapla_centro_wrap">
        <div class="plapla_centro_cont">
          <img src="@/assets/imgs/eshoy_home_top03.png" alt="" />
        </div>
      </div>
    </div>-->

    <footPage></footPage>
  </div>
  <div v-else class="mobile_viewrap">
    <div class="mobile_wrap">
      <mobNav :activeNav="activeNav"></mobNav>
    </div>
    <div class="mobhome_banner">
      <div class="mobhome_banner_cont">
        <img src="@/assets/mobimg/mob_home_banner.png" />
      </div>
    </div>
    <div class="mobhome_download">
      <div class="mobhome_dcont">
        <div class="mobhome_dcont_items">
          <a
                  href="https://play.google.com/store/apps/details?id=cash.prestamos.credit.instalacion.kueski.plapla"
                  target="_blank"
                  class="playBtn"
          >
            <img src="@/assets/mobimg/mob_home_googleplay.png" />
          </a>
        </div>
        <div class="mobhome_dcont_items">
          <!--<img src="@/assets/mobimg/mob_home_ios.png" />-->
        </div>
      </div>
    </div>
    <div class="mobhome_onewrap">
      <div class="mobhome_oneview">
        <img src="@/assets/mobimg/mob_home_01.png" />
      </div>
      <div class="mobhome_border scale-1px-home"></div>
    </div>

    <div class="mobhome_onewrap">
      <div class="mobhome_twoview">
        <img class="mobhome_tvbgimg" src="@/assets/mobimg/mob_home_02.png" />
        <div class="mobhome_tview">
          <div class="eshoy_slider_cont mobhome_tview_slider">
            <div class="loan-content-box">
              <div class="moneybox">
                $ <span id="money">{{ dealNumber(sliderValue) }}</span>
              </div>
              <div class="loan-select-box">
                <div class="loan-select-item"
                     :class="isActive == 91 ? 'selected' : ''"
                     @click="getDays(91)"
                >
                  91 Días
                </div>
                <div class="loan-select-item"
                     :class="isActive == 120 ? 'selected' : ''"
                     @click="getDays(120)"
                >
                  120 Días
                </div>
                <div class="loan-select-item"
                     :class="isActive == 180 ? 'selected' : ''"
                     @click="getDays(180)"
                >
                  180 Días
                </div>
              </div>

              <div class="sliderbox_wrap">
                <div class="sliderbox_left">
                  <div class="sliderbox_cimg">
                    <img src="@/assets/img/eshoy_gold_small.png" alt="">
                  </div>
                  <div class="sliderbox_ctext">$<span>200</span></div>
                </div>
                <div class="sliderbox_middle">
                  <div class="sliderBox">
                    <el-slider
                            v-model="sliderValue"
                            :min="200"
                            :max="24000"
                            :show-tooltip="false"
                    ></el-slider>
                  </div>
                </div>
                <div class="sliderbox_right">
                  <div class="sliderbox_cimg">
                    <img src="@/assets/img/eshoy_gold_more.png" alt="">
                  </div>
                  <div class="sliderbox_ctext">$<span>24,000</span></div>
                </div>
              </div>
            </div>

            <div class="eshoy_slider_btns">
              <div class="eshoy_slider_btn_view animate__animated animate__infinite animate__pulse">
                <img src="@/assets/imgs/plapla_slider_btn.png" alt="" />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="mobhome_border scale-1px-home"></div>
    </div>

    <div class="mobhome_onewrap">
      <div class="mobhome_oneview" style="width: 88.89%;">
        <img src="@/assets/mobimg/mob_home_03.png" />
      </div>
      <div class="mobhome_thrview" style="width: 88.89%;" @click="gotoHelp">
        <img src="@/assets/mobimg/mob_home_04.png" />
      </div>
      <div class="mobhome_border scale-1px-home"></div>
    </div>

    <!--<div class="mobhome_onewrap">
      <div class="mobhome_oneview" style="width: 88.89%;">
        <img src="@/assets/mobimg/mob_home_05.png" />
      </div>
      <div class="mobhome_fivborder"></div>
    </div>-->

      <mobFooter></mobFooter>

  </div>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import mobNav from "@/components/mobNav.vue";
import mobFooter from "@/components/mobfooter.vue";
import mobileOrpc from "@/mixins/index";

export default {
    name: 'Index',
    components: { headNav, homeNav, footPage,mobNav, mobFooter },
    mixins: [mobileOrpc],
    data () {
      return {
        activeNav: "Inicio",
        scroll: 0,
        changeNum: 0,
        sliderValue: 20000,
        isActive: 91,
      }
    },
    created() {
      let nav = localStorage.getItem('activeNav');
      if (nav) {
        this.activeNav = nav;
      } else {
        localStorage.setItem('activeNav', this.activeNav);
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop=0;

      console.log('是否为移动端')
      console.log(this.is_mobile)
    },
    methods: {
      gotoHelp() {
        this.$router.push({
          path: '/help',
        })
      },
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
      getDays(day) {
        this.isActive = day;
      },
      dealNumber(num) {
        if (num != 0 && num) {
          num = num + "";
          let splitList = num.split(".");
          //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
          let intStrList = splitList[0]
                  .split("")
                  .reverse()
                  .join("")
                  .match(/(\d{1,3})/g);
          //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
          let intStr = intStrList.join(",").split("").reverse().join("");
          return intStr;
        }
        return num;
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  .libe_home_wrap{
    width: 100%;
    height: auto;
    position: relative;
    background: #13151A;
  }
  .libe_home_nav{
    width: 100%;
    height: auto;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1010;
  }
  .libe_homenav{
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 8;
  }
  .libe_home_banner{
    width: 100%;
    height: 730px;
    position:relative;
    overflow:hidden;
    z-index: 2;
  }
  .libe_home_banner_img{
    width: 1920px;
    position:absolute;
    left:50%;
    margin-left:-960px;
  }
  .eshoy_home_google_link{
    width: 1300px;
    height: auto;
    margin: 0 auto;
    position: relative;
  }
  .libe_home_top{
    width: 1200px;
    height: 495px;
    margin: 0 auto;
    position: relative;
    background: #13151A;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 120px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255,255,255, 0.2);
  }
  .libe_home_top_img{
    width: 1119px;
    height: 256px;
    margin: 0 auto;
  }
  .libe_home_top_img img{
    display: block;
    width: 100%;
  }
  .libe_home_down{
    width: 1300px;
    height: auto;
    margin: 0 auto;
    padding-top: 140px;
  }
  .libe_home_down img{
    display: block;
    width: 100%;
  }
  .Index {
    width: 100%;
    height: 100%;
    background-color: #fff;
    margin: 0;
    padding: 0;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .google_link_wrap{
    width: 180px;
    height: 54px;
    position: absolute;
    left: 50px;
    top: -180px;
    z-index: 6;
  }
  .google_link_wrap img{
    display: block;
    width: 100%;
    cursor: pointer;
  }
  .ios_link_wrap{
    width: 180px;
    height: 54px;
    position: absolute;
    left: 262px;
    top: -180px;
    z-index: 6;
  }
  .ios_link_wrap img{
    display: block;
    width: 100%;
    cursor: pointer;
  }
  .eshoy_slider_wrap{
    width: 100%;
    height: 864px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 120px;
    background: #13151A;
  }
  .eshoy_slider_cont{
    width: 1200px;
    height: 624px;
    margin: 0 auto;
    background: url(../assets/imgs/eshoy_slider_bg.png) no-repeat center center;
    background-size: 100% 100%;
  }
  .loan-content-box {
    width: 100%;
    height: auto;
    padding-top: 85px;
  }

  .loan-select-box {
    width: 70%;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
  }

  .loan-select-item {
    width: 200px;
    height: 50px;
    background: #332740;
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.06);
    border-radius: 25px;
    border: 1px solid #332740;
    color: #FFFFFF;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
  }

  .Index .loan-select-item.selected {
    background: rgba(165,247,170,0.06);
    border: 1px solid rgba(165,247,170,0.8);
    color: #A5F7AA;
    font-size: 18px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
  }

  .moneybox {
    font-size: 58px;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    font-family: Helvetica;
    text-align: center;
    padding-bottom: 74px;
  }

  .moneybox span {
    font-size: 58px;
  }

  .sliderBox {
    width: 546px;
    height: auto;
    background: #E4EFEB;
    border-radius: 5px;
    margin: 24px auto 0 auto;
    position: relative;
  }

  .range {
    display: none;
    justify-content: space-between;
    margin-top: 35px;
  }

  .range p {
    font-size: 16px;
    color: #666;
    font-weight: 500;
  }

  .range p span {
    font-size: 18px;
  }
  .el-slider__runway {
    height: 10px !important;
    margin: 0 !important;
    background-color: #E4EFEB !important;
    border-radius: 5px !important;
  }

  .el-slider__bar {
    height: 10px !important;
    border-radius: 5px !important;
    background-color: #2FA96B !important;
  }

  .el-slider__button-wrapper {
    width: 69px !important;
    height: 70px !important;
    background: url(../assets/img/sliderBtn.png) top center no-repeat;
    background-size: cover;
    cursor: pointer;
    border: none !important;
    background-color: transparent !important;
    top: -27px !important;
  }

  .el-slider__button {
    border: none !important;
    background-color: transparent !important;
  }
  .sliderbox_wrap{
    width: 762px;
    height: 86px;
    padding-top: 37px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .sliderbox_left{
    width: 88px;
    height: 86px;
  }

  .sliderbox_right{
    width: 88px;
    height: 86px;
  }
  .sliderbox_cimg{
    width: 88px;
    height: 50px;
  }
  .sliderbox_ctext{
    width: 100%;
    height: 36px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 500;
    color: #8C8480;
    line-height: 36px;
    text-align: center;
  }
  .sliderbox_ctext span{
    padding-left: 6px;
  }
  .eshoy_slider_btns{
    width: 378px;
    height: 72px;
    margin: 80px auto 0 auto;
    cursor: pointer;
  }
  .eshoy_slider_btn_view{
    width: 378px;
    height: 72px;
  }
  .eshoy_slider_btns img{
    display: block;
    width: 100%;
  }
  .libe_home_down_cont{
    width: 100%;
    height: 583px;
    padding-top: 80px;
  }
  .libe_home_dview{
    width: 648px;
    margin: 0 auto;
    position: relative;
  }
  .libe_home_dvitem_one{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-left: 107px;
    padding-right: 60px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
  }
  .libe_home_dvitem_one img{
    display: block;
    width: 100%;
  }
  .libe_home_dvitem_two{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-right: 109px;
    position: absolute;
    left: 0;
    top: 101px;
    z-index: 4;
  }
  .libe_home_dvitem_two img{
    display: block;
    width: 100%;
  }
  .libe_home_dvitem_thr{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-left: 109px;
    position: absolute;
    left: 0;
    top: 203px;
    z-index: 3;
  }
  .libe_home_dvitem_thr img{
    display: block;
    width: 100%;
  }
  .libe_home_dvitem_fur{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-right: 109px;
    position: absolute;
    left: 0;
    top: 304px;
    z-index: 2;
  }
  .plapla_centro_view{
    width: 100%;
    height: auto;
    margin: 0 auto;
    background: #13151A;
  }
  .plapla_centro_wrap{
    width: 1200px;
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 120px 0 120px 0;
    border-top: 1px solid rgba(255,255,255,0.2);
  }
  .plapla_centro_cont{
    width: 100%;
    height: auto;
  }
  .plapla_centro_cont img{
    display: block;
    width: 100%;
  }
  .plapla_centro_desc{
    width: 100%;
    height: auto;
    padding-top: 50px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
  }
  .plapla_centro_desc span{
    color: #39CA80;
    text-decoration: underline;
  }

  .mobile_viewrap{
    width: 100%;
    background: #13151A;
  }
  .mobile_wrap{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
  }
  .mobile_wrap .van-cell{
    padding: 0;
    background: #ffffff !important;
  }
  .mobile_wrap .van-collapse-item{
    background: #ffffff !important;
  }
  .mobile_wrap .van-cell--clickable:active {
    background: #ffffff !important;
  }
  .mobile_wrap .van-collapse-item__content{
    padding: 0;
    background: radial-gradient( 153% 100% at 50% 27%, #FF7648 0%, rgba(255,255,255,0) 100%) !important;
  }
  .mobile_wrap .common_problem_wrap_mobile{
    width: 100%;
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
  }
  .mobile_wrap .common_problem_view_mobile{
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.555556rem 0 0.555556rem;
    background: #ffffff;
  }
  .mobile_wrap .common_title_wrap{
    width: 100%;
    height: 1.777778rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 0 0 0.694444rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mobile_wrap .common_title_left{
    width: auto;
    height: 0.666667rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mobile_wrap .common_tleft_icon{
    width: 3.166667rem;
    height: 1.083333rem;
  }
  .mobile_wrap .common_tleft_icon img{
    display: block;
    width: 100%;
  }
  .mobile_wrap .common_tleft_text{
    width: auto;
    padding-left: 0.277778rem;
    font-size: 0.388889rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8C8E94;
  }
  .mobile_wrap .common_title_left .isopen{
    color: #FFFFFF;
  }
  .mobile_wrap .common_title_right{
    width: auto;
    height: 1.777778rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-right: 0.833333rem;
  }
  .mobile_wrap .common_trview{
    width: 0.666667rem;
    height: 0.666667rem;
  }
  .mobile_wrap .common_trview img{
    display: block;
    width: 100%;
  }
  .mobile_wrap .common_children_wrap{
    width: 100%;
    height: calc(100vh - 1.777778rem);
    box-sizing: border-box;
    padding-top: 0.555556rem;
    padding-left: 0.555556rem;
    padding-bottom: 0.555556rem;
    padding-right: 0;
  }
  .mobile_wrap .children_title_wrap{
    width: 100%;
    height: auto;
    padding-top: 0.555556rem;
  }
  .mobile_wrap .children_title_left{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
  }
  .mobile_wrap .children_tleft_icon{
    width: 0.5rem;
    height: 0.472222rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mobile_wrap .children_tleft_icon img{
    display: block;
    width: 0.277778rem;
    height: 0.277778rem;
  }
  .mobile_wrap .children_tleft_text{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding-right: 1.055556rem;
    font-size: 0.333333rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255,255,255,0.8);
    line-height: 0.472222rem;
  }
  .mobile_wrap .children_cont{
    width: 100%;
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.222222rem 1.055556rem 0 0.472222rem;
    overflow-y: scroll;
  }
  .mobile_wrap .children_cont_items{
    width: 100%;
    height: 1.555556rem;
    font-size: 0.444444rem;
    color: #5A5A63;
    line-height: 1.555556rem;
  }
  .mobile_wrap .children_citactive{
    color: #2FA96B;
    font-weight: bold;
  }
  .mobhome_banner{
    width: 100%;
    height: auto;
    padding-top: 1.777778rem;
  }
  .mobhome_banner_cont{
    width: 100%;
    height: auto;
  }
  .mobhome_banner_cont img{
    display: block;
    width: 100%;
  }
  .mobhome_download{
    width: 100%;
    height: 1px;
    position: relative;
  }
  .mobhome_dcont{
    width: 100%;
    height: 0.888889rem;
    display: flex;
    justify-content: flex-start;
    position: absolute;
    left: 0;
    top: -1.916667rem;
  }
  .mobhome_dcont_items{
    width: 3.083333rem;
    height: 0.888889rem;
    box-sizing: border-box;
    padding-left: 0.555556rem;
  }
  .mobhome_dcont_items img{
    display: block;
    width: 100%;
  }
  .mobhome_onewrap{
    width: 100%;
    height: auto;
    padding-top: 1.944444rem;
  }
  .mobhome_oneview{
    width: 71.53%;
    height: auto;
    margin: 0 auto;
  }
  .mobhome_oneview img{
    display: block;
    width: 100%;
  }
  .mobhome_border{
    width: 88.89%;
    padding-top: 1.916667rem;
    margin: 0 auto;
  }
  .mobhome_twoview{
    width: 88.89%;
    height: auto;
    margin: 0 auto;
    position: relative;
  }
  .mobhome_tvbgimg{
    display: block;
    width: 100%;
  }
  .mobhome_tview{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
  }
  .mobhome_thrview{
    width: 100%;
    height: 0.916667rem;
    margin: 11px auto 0 auto;
  }
  .mobhome_thrview img{
    width: 43.47%;
    display: block;
    margin: 0 auto;
  }
  .mobhome_fivborder{
    width: 88.89%;
    padding-top: 1.916667rem;
    margin: 0 auto;
  }
  .mobfooter_wrap{
    width: 100%;
    height: auto;
    background: #0A0B0E;
    padding-top: 1.944444rem;
    padding-bottom: 1.944444rem;
  }
  .mobfooter_cont{
    width: 88.89%;
    height: auto;
    margin: 0 auto;
  }
  .mobfooter_title{
    width: 100%;
    height: 0.444444rem;
    font-size: 0.444444rem;
    font-weight: 600;
    color: #E8E8E9;
    line-height: 0.444444rem;
  }
  .mobfooter_list{
    width: 100%;
    height: auto;
    padding-top: 0.333333rem;
  }
  .mobfooter_items{
    width: 100%;
    height: 1.5rem;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .mobfooter_ileft{
    width: auto;
    height: 1.5rem;
    font-size: 0.388889rem;
    font-weight: 400;
    color: #E8E8E9;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mobfooter_ileft_active{
    color: #39CA80;
  }
  .mobfooter_iright{
    width: 0.277778rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
  }
  .mobfooter_iright img{
    display: block;
    width: 100%;
    height: 0.416667rem;
  }
  .mobfooter_middle{
    width: 100%;
    height: auto;
    padding-top: 1.388889rem;
  }
  .mobfooter_mimg{
    width: 100%;
    padding-top: 0.611111rem;
  }
  .mobfooter_mimg img{
    display: block;
    width: 4.861111rem;
  }
  .mobfooter_down{
    width: 100%;
    padding-top: 1.388889rem;
  }
  .mobfooter_dlist{
    width: 100%;
    height: auto;
    padding-top: 0.333333rem;
  }
  .mobfooter_dlitem{
    width: 100%;
    height: auto;
    padding-top: 0.555556rem;
    font-size: 0.388889rem;
    font-weight: 400;
    color: #B6B8BF;
  }
  .mobhome_tview .eshoy_slider_cont{
      width: 100%;
      background: none;
  }
  .mobhome_tview .sliderbox_wrap{
      width: 87.5%;
      margin: 0 auto;
  }
  .mobhome_tview .sliderbox_left{
      width: 16.3%;
      height: 1.194444rem;
  }
  .mobhome_tview .sliderbox_middle{
      width: 60%;
  }
  .mobhome_tview .sliderbox_right{
      width: 16.3%;
      height: 1.194444rem;
  }
  .mobhome_tview .sliderbox_cimg{
     width: 100%;
     height: 0.694444rem;
  }
  .mobhome_tview .sliderbox_ctext{
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 0.25rem;
  }
  .mobhome_tview .sliderBox{
      width: 100%;
  }
  .mobhome_tview .loan-content-box{
     padding-top: 1.111111rem;
  }
  .mobhome_tview .moneybox{
     font-size: 0.805556rem;
     padding-bottom: 1.111111rem;
  }
  .mobhome_tview .moneybox span {
    font-size: 0.805556rem;
  }
  .mobhome_tview .loan-select-box{
    width: 87.5%;
  }
  .mobhome_tview .loan-select-item {
    width: 30%;
    height: 0.833333rem;
    font-size: 12px;
    line-height: 0.833333rem;
  }
  .mobhome_tview .loan-select-item.selected{
    font-size: 12px;
    background: rgba(165,247,170,0.06);
    border: 1px solid rgba(165,247,170,0.8);
    color: #A5F7AA;
    font-weight: 600;
  }
  .mobhome_tview .sliderbox_wrap{
    padding-top: 0.583333rem;
  }
  .mobhome_tview .sliderBox{
    margin: 0.35rem auto 0 auto;
  }
  .mobhome_tview .el-slider__bar{
    height: 0.138889rem !important;
    border-radius: 0.069444rem !important;
  }
  .mobhome_tview .el-slider__runway{
    height: 0.138889rem !important;
    border-radius: 0.069444rem !important;
  }
  .mobhome_tview .el-slider__button-wrapper{
      width: 0.972222rem !important;
      height: 0.972222rem !important;
      top: -0.388889rem !important;
  }
  .mobhome_tview .sliderbox_wrap{
      height: 2.2rem;
  }
  .mobhome_tview .eshoy_slider_btns{
      width: 5.25rem;
      height: 1.0rem;
      margin-top: 0;
  }
  .mobhome_tview .eshoy_slider_btn_view{
      width: 5.25rem;
      height: 1.0rem;
  }

  /* 1px边框 底部*/
  .scale-1px-home{
    position: relative;
    border:none;
  }
  .scale-1px-home:after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.2);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }

  /* 1px边框 底部*/
  .scale-1px{
    position: relative;
    border:none;
  }
  .scale-1px:after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    background: #DEE0E6;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  /* 1px边框 顶部*/
  .scaletop-1px{
    position: relative;
    border:none;
  }
  .scaletop-1px:after{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    background: #DEE0E6;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  /* 1px边框 右边*/
  .scaleright-1px{
    position: relative;
    border:none;
  }
  .scaleright-1px:after{
    content: '';
    position: absolute;
    right: 0;
    background: #DEE0E6;
    width: 1px;
    height: 100%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  /* 1px边框 左边*/
  .scaleleft-1px{
    position: relative;
    border:none;
  }
  .scaleleft-1px:after{
    content: '';
    position: absolute;
    left: 0;
    background: #DEE0E6;
    width: 1px;
    height: 100%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }

  .home_page_root {
    width: 100%;
    min-height: 100%;
  }
</style>
